<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            <CRow style="width:100%">
              <CCol md="12" lg="12" xl="12"> Operaciones </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <div class="inventario-panel" >
              <section
                class="inventario-panel-row"
                v-for="(row, i) in panel"
                v-if="row.apps.length>0"
                :key="i"
              >
                <h4 class="inventario-panel-subtitle">{{ row.subtitle }}</h4>
                <article
                  class="inventario-panel-col"
                  v-for="(item, ix) in row.apps"
                  :key="ix"
                >
                  <router-link :to="item.to || '/'">
                    <i :class="item.icon"></i>
                    <span>{{ item.name }}</span>
                  </router-link>
                </article>
              </section>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CredentialMixin from '../mixins/CredentialMixin';

export default {
  name: "OperacioesPage",
  components: {
  },
  mixins: [CredentialMixin],
  data() {
    return {
      showCalculosAdministrativos: false,
      
    };
  },
  created() {

    this.$store
        .dispatch("customHTTP", {
          schema: "configuracion",
          filter: {
            where: [
              {
                field: "payload->parametro",
                value: "calculos_administrativos",
                operator: "="
              }
            ]
          }
        }).then(res => {
          this.showCalculosAdministrativos = res.data.length>0;
        });
  },

  computed: {
    panel(){
      return this._panel.map(m=>{
        return {
          ...m,
          apps: m.apps.filter(f=>{
            if(f.credential){
              return this.hasTheCredential(f.credential);
            }
            return true;
          })
        }
      })
    },
    _panel() {
      return [
          {
            subtitle: "Administración",
            apps: [
              {
                name: "Gastos",
                to: {
                  name: "Gasto"
                },
                icon: "fa fa-files-o",
                credential: "@documento:schema=gastos\\|.*consultar"
              }
            ]
          },
          {
            subtitle: "Captura de Nómina",
            apps: [
              {
                name: "Labores",
                to: {
                  name: "Labor"
                },
                icon: "fa fa-tag",
                credential: "@documento:schema=labores\\|.*consultar"
              },
              {
                name: "Prestamos",
                to: {
                  name: "Prestamo"
                },
                icon: "fa fa-handshake-o",
                credential: "@documento:schema=prestamos\\|.*consultar"
              },
              {
                name: "Bonos",
                to: {
                  name: "Bono"
                },
                icon: "fa fa-money",
                credential: "@documento:schema=bonos\\|.*consultar"
              },
              {
                name: "Caja de Ahorro",
                to: {
                  name: "CajaAhorro"
                },
                icon: "fa fa-archive",
                credential: "@documento:schema=caja_de_ahorro\\|.*consultar"
              }
            ]
          },
          {
            subtitle: "Cálculos automáticos de Nómina",
            apps: [
              {
                name: "Asistencias",
                to: {
                  name: "Asistencia"
                },
                icon: "fa fa-check",
                credential: "@documento:schema=asistencias\\|.*consultar"
              },
              {
                name: "Jornadas",
                to: {
                  name: "Jornada"
                },
                icon: "fa fa-check",
                credential: "@documento:schema=jornadas\\|.*consultar"
              },
              ...this.showCalculosAdministrativos?[{
                name: "Prestaciones",
                to: {
                  name: "Prestacion"
                },
                icon: "fa fa-tag",
                credential: "@documento:schema=prestaciones\\|.*consultar"
              },
              {
                name: "Préstamos aplicados",
                to: {
                  name: "PrestamoAplicado"
                },
                icon: "fa fa-handshake-o",
                credential: "@documento:schema=prestamos_aplicados\\|.*consultar"
              },
              {
                name: "Bonos aplicados",
                to: {
                  name: "BonoAplicado"
                },
                icon: "fa fa-money",
                credential: "@documento:schema=bonos_aplicados\\|.*consultar"
              },
              {
                name: "Caja de ahorro aplicada",
                to: {
                  name: "CajaAhorroAplicado"
                },
                icon: "fa fa-archive",
                credential: "@documento:schema=caja_de_ahorro_aplicadas\\|.*consultar"
              },
              
              {
                name: "Cálculos Administrativos",
                to: {
                  name: "CalculoAdministrativo"
                },
                icon: "fa fa-solid fa-calculator",
                credential: "@documento:schema=calculos_administrativos\\|.*consultar"
              }]:[],
            ]
          },
          {
            subtitle: "Nómina",
            apps: [
              ...this.showCalculosAdministrativos?[
              {
                name: "Consultar",
                to: {
                  name: "CalculoAdministrativoNomina"
                },
                icon: "fa fa-solid fa-list",
                credential: "@documento:schema=calculos_administrativos\\|.*consultar"
              }]:[],
            ]
          },
          {
            subtitle: "Producción",
            apps: [
              // {
              //   name: "Riego",
              //   to: {
              //     name: "Riego"
              //   },
              //   icon: "fa fa-tint"
              // },
              {
                name: "Producciones",
                to: {
                  name: "Produccion"
                },
                icon: "fa fa-tasks",
                credential: "@documento:schema=producciones\\|.*consultar"
              },
              {
                name: "Entregas",
                to: {
                  name: "Entrega"
                },
                icon: "fa fa-sign-in",
                credential: "@documento:schema=entregas\\|.*consultar"
              }
            ]
          }
        ]
    }
  },

  methods: {}
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.line {
  width: 100%;
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.z-custom {
  z-index: 1;
}
.z-custom-2 {
  z-index: 4;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}

.custom-width-btn {
  width: 40%;
}
.custom-heigth-btn {
  width: 100%;
}
.custom-font-size {
  font-size: 1rem;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
<style lang="scss" scoped>
.inventario-panel {
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 90%;
  margin: 0 auto;
  section.inventario-panel-row {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    h4.inventario-panel-subtitle {
      width: 100%;
      margin: 0;
      text-transform: capitalize;
    }
    article.inventario-panel-col {
      width: 120px;
      height: 120px;
      background-color: #172b4d;
      border-radius: 20px;
      gap: 10px;
      a {
        color: #fff;
        display: grid;
        font-size: 15.5px;
        width: 100%;
        height: 100%;
        text-align: center;
        grid-template-rows: 1fr 1fr;
        align-content: center;
        &:hover {
          text-decoration: none;
        }
        i {
          font-size: 32px;
          align-self: end;
        }
      }
    }
  }
}
</style>
